import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  field: {
    marginBottom: 24,
    width: '100%',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  error: {
    position: 'absolute',
    color: theme.palette.errors,
    fontSize: theme.typography.pxToRem(9),
    paddingLeft: 16,
    top: '100%',
  },
}));
